export const authDomain = import.meta.env.VITE_AUTH_DOMAIN as string;
export const authAudience = import.meta.env.VITE_AUTH_AUDIENCE as string;
export const authClientId = import.meta.env.VITE_AUTH_CLIENT_ID as string;
export const studioApiUrl = import.meta.env.VITE_STUDIO_API_URL as string;
export const studioApiTtsUrl = import.meta.env.VITE_TTS_ENDPOINT as string;
export const didApiUrl = import.meta.env.VITE_DID_API_URL as string;
export const persistentTalksDns = import.meta.env.VITE_PERSISTENT_TALKS_DNS as string;
export const persistentClipsDns = import.meta.env.VITE_CLIPS_PERSISTENT_DNS as string;
export const projectDns = import.meta.env.VITE_PROJECTS_DNS as string;
export const translationDns = import.meta.env.VITE_TRANSLATIONS_DNS as string;
export const persistentBucket = import.meta.env.VITE_PERSISTENT_TALKS_BUCKET as string;
export const persistentClipsBucket = import.meta.env.VITE_PERSISTENT_CLIPS_BUCKET as string;
export const projectsBucket = import.meta.env.VITE_PROJECTS_BUCKET as string;
export const createImagesBucket = import.meta.env.VITE_CREATE_IMAGES_BUCKET as string;
export const createImagesDns = import.meta.env.VITE_CREATE_IMAGES_DNS as string;
export const nodeEnv = import.meta.env.VITE_NODE_ENV as string;
export const autoRefetchInterval = import.meta.env.VITE_AUTO_REFETCH_INTERVAL;
export const websiteBucketUrl = import.meta.env.VITE_WEBSITE_BUCKET_URL as string;
export const maxImageSizeInBytes = parseInt(import.meta.env.VITE_MAX_IMAGE_BYTES as string);
export const maxAudioSizeInBytes = parseInt(import.meta.env.VITE_MAX_AUDIO_BYTES as string);
export const base = (import.meta.env.VITE_BASE as string) ?? '/';
export const version = import.meta.env.VITE_VERSION as string;
export const launchdarklyClientKey = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_KEY as string;
export const mixpanelKey = import.meta.env.VITE_MIXPANEL_KEY as string;
export const supportFormUrl = import.meta.env.VITE_SUPPORT_FORM_URL as string;
export const newSupportFormUrl = import.meta.env.VITE_NEW_SUPPORT_FORM_URL as string;
export const formPortalId = import.meta.env.VITE_FORM_PORTAL_ID as string;
export const formGuid = import.meta.env.VITE_FORM_GUID as string;
export const onBoardingFormGuid = import.meta.env.VITE_ONBOADING_FORM_GUID as string;
export const readmeIoUrl = 'https://docs.d-id.com';
export const mobileAppUrl = 'https://eu1.hubs.ly/H0f1sbx0';
export const appAndroidUrl = 'https://play.google.com/store/apps/details?id=com.deidentification.studio';
export const appIosUrl = 'https://apps.apple.com/us/app/creative-reality-studio/id6463755563';
export const appUrl = 'https://eu1.hubs.ly/H0f1sbx0';
export const watermarkUrl = 'd-id-watermark';
export const audiosDns = import.meta.env.VITE_AUDIOS_DNS as string;
export const minutesToCreditsDuration = 15;
export const minCreditsToBuy = parseInt(import.meta.env.VITE_MIN_CREDITS_TO_BUY as string);
export const logosUrl = import.meta.env.VITE_LOGOS_URL as string;
export const pricingPageUrl = import.meta.env.VITE_PRICING_PAGE_URL as string;
export const dreamsMetadata = import.meta.env.VITE_DREAMS_METADATA_URL as string;
export const validTextLength = 5;
export const priceCreditsClaimsKey = import.meta.env.VITE_PRICE_CREDITS_CLAIMS_KEY as string;
export const stripePriceIdClaimsKey = import.meta.env.VITE_STRIPE_PRICE_ID as string;
export const noticeableWidgetId = 'iZjuQwIb2SkvZqBECWBD';
export const polotnoKey = import.meta.env.VITE_PLAN_POLOTNO_KEY as string;
export const listenTrialMaxWords = parseInt(import.meta.env.VITE_LISTEN_TRIAL_MAX_WORDS || 20);
export const webSocketUrl = import.meta.env.VITE_WS_ENDPOINT as string;
export const pricingUrl = 'https://www.d-id.com/pricing/api?from=studio_settings';
export const pricingStudioUrl = 'https://www.d-id.com/pricing/studio/';
export const agentDomain = import.meta.env.VITE_AGENT_DOMAIN as string;
export const studioDomain = import.meta.env.VITE_STUDIO_DOMAIN as string;
export const productHunt = 'https://www.producthunt.com/posts/d-id-creative-reality-studio-mobile-app';
export const churnkeyAppId = (import.meta.env.VITE_CHURNKEY_APP_ID as string) || 'pwu25aa2j';
export const churnkeyEnvironment = import.meta.env.VITE_CHURNKEY_ENVIRONMENT;
export const chameleonApiKey = import.meta.env.VITE_CHAMELEON_API_KEY as string;
export const contactToUsEmail = 'shani.golan@deidentification.co';
export const salesUrl =
    'https://www.d-id.com/contact-sales/?utm_campaign=in-app-contact-us&utm_source=in-app-contact-us&utm_medium=in-app-contact-us';
export const minimumCompanySizeForSales = 100;
export const googleApiKey = import.meta.env.VITE_GOOGLE_API_KEY as string;
export const canvaAppUrl = 'https://www.canva.com/apps/AAFapKzFFus/d-id-ai-presenters';
export const powerpointAppUrl = 'https://appsource.microsoft.com/en-us/product/office/wa200004566?tab=overview';
export const tolstoyAppUrl = 'https://app.gotolstoy.com/did/landing?utm_source=d-id_studio_apps';
export const translationFormulaSlope = 6.9;
export const translationFormulaIntercept = 0;
export const translationWorkerActivationTime = 180;
// 2 = inflate the calc by 30%
export const expressFormulaSlope = 4.38 + 2;
export const expressFormulaIntercept = 16.65;
export const expressWorkerActivationTime = 180;
export const TermsUrl = 'https://www.d-id.com/studio-end-user-license-agreement/';
export const PrivacyUrl = 'https://www.d-id.com/privacy-policy/';
export const dataDogApplicationId = import.meta.env.VITE_DATADOG_APPLICATION_ID as string;
export const dataDogClientToken = import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string;

// "off" | "console" | "mixpanel" | "console+mixpanel"
export const timingMode = ((import.meta.env.VITE_TIMING_MODE as string) || 'off').toLowerCase();

export const analyticsEnabled = ((import.meta.env.VITE_ANALYTICS_ENABLED as string) || 'false').toLowerCase() === 'true';
